import { Box } from "@mui/material";
import { NameField, TitleSelectComponent, SurnameField } from "@soqs/common";
import IDSelectionComponent from "./IDSelection";
import { Field } from "react-final-form";
import RadioGroupControl from "./RadioGroup";
import DelegateDetails from "./DelegateDetails";
import { useSelector } from "react-redux";
import { dropdownOptions } from "../../../features/CaptureDetailsSlice";
import {
  CaptureDetailsPrefixConstants,
  RequestorSubType,
} from "../../../models/Enums";
import TaxpayerDetails from "./TaxpayerDetails";
import MenuItemsForDropdown from "../../FormComponents/MenuItemsForDropdown/MenuItemsForDropdown";

export interface RepresentativeDetailsProps {
  representativeType: string | undefined;
}

const RepresentativeDetails = (props: RepresentativeDetailsProps) => {
  const selectOptions = useSelector(dropdownOptions);

  return (
    <>
      {props.representativeType === RequestorSubType.OnceOffMandate ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={(theme) => ({
              flex: "0 0 49%",
              [theme.breakpoints.down("sm")]: {
                flex: "0 0 100%",
              },
            })}
          >
            <TitleSelectComponent
              id="once-off-mandate-title"
              name="onceOffMandateTitle"
              options={MenuItemsForDropdown("titles", selectOptions)}
              required={true}
              parse={(value: any) => value ? value?.trim() : ""}
            />
          </Box>

          <Box
            sx={(theme) => ({
              flex: "0 0 49%",
              [theme.breakpoints.down("sm")]: {
                flex: "0 0 100%",
              },
            })}
          >
            <NameField
              id="once-off-mandate-name"
              name="onceOffMandateName"
              required={true}
              parse={(value: any) => value ? value?.trim() : ""}
            />
          </Box>

          <Box
            sx={(theme) => ({
              flex: "0 0 49%",
              [theme.breakpoints.down("sm")]: {
                flex: "0 0 100%",
              },
            })}
          >
            <SurnameField
              id="once-off-mandate-surname"
              name="onceOffMandateSurname"
              required={true}
              parse={(value: any) => value ? value?.trim() : ""}
            />
          </Box>
        </Box>
      ) : null}

      <IDSelectionComponent
        prefix={CaptureDetailsPrefixConstants.Representative}
      />

      <TaxpayerDetails entityArray="entityType" />

      <Box>
        <Field
          name="radio-group-control"
          fullWidth
          component={RadioGroupControl}
          inputProps={{ wording: "Representative" }}
          attending={
            props.representativeType === RequestorSubType.OnceOffMandate
              ? "yes"
              : undefined
          }
        />
      </Box>

      <DelegateDetails />
    </>
  );
};

export default RepresentativeDetails;
